import { component as defineComponent } from 'flightjs';

function HideableElement() {
    this.placeholderElement = null;

    this.attributes({
        showEvent: 'uiShowElement',
        hideEvent: 'uiHideElement',
        stateAttr: 'data-hidden',
        usePlaceholder: false,
        default: 'hidden',
    });

    this.show = function () {
        if (this.attr.usePlaceholder && this.placeholderElement !== null) {
            this.placeholderElement.remove();
        }
        this.$node.removeAttr(this.attr.stateAttr);
    };

    this.hide = function () {
        var elemHeight;

        if (this.attr.usePlaceholder) {
            elemHeight = this.$node.outerHeight(true);
            this.placeholderElement = $('<div/>', {
                'data-hideable-element-placeholder': true,
            }).css({
                height: elemHeight,
            });
            this.placeholderElement.insertAfter(this.$node);
        }
        this.$node.attr(this.attr.stateAttr, true);
    };

    this.after('initialize', function () {
        if (this.attr.default === 'hidden') {
            this.hide();
        } else if (this.attr.default === 'visible') {
            this.show();
        }

        if (this.attr.showEvent) {
            this.on(document, this.attr.showEvent, this.show);
        }

        if (this.attr.hideEvent) {
            this.on(document, this.attr.hideEvent, this.hide);
        }
    });
}

export default defineComponent(HideableElement);



// WEBPACK FOOTER //
// ./src/web/js/app/ui/hideable-element.js